var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5553 40C8.77158 40 0 31.029 0 20C0 8.97104 8.77158 0 19.5553 0C24.4687 0 29.109 1.84304 32.7164 5.20353C33.0924 5.55376 33.0914 6.15187 32.7321 6.51994L31.1053 8.18625C30.7458 8.55456 30.164 8.55239 29.7837 8.20655C26.9621 5.64055 23.3631 4.23829 19.5553 4.23829C11.0554 4.23829 4.14405 11.3115 4.14405 20C4.14405 28.6885 11.06 35.7617 19.5553 35.7617C23.2393 35.7617 26.7468 34.4383 29.5314 32.0136C29.9187 31.6764 30.5 31.6866 30.852 32.0621L32.4461 33.7632C32.7981 34.1387 32.787 34.7368 32.4039 35.0789C28.8419 38.2595 24.3123 40 19.5553 40Z",
    fill: "#E0F64B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 19.5C29 24.7467 24.7467 29 19.5 29C14.2533 29 10 24.7467 10 19.5C10 14.2533 14.2533 10 19.5 10C24.7467 10 29 14.2533 29 19.5ZM25 19.5C25 22.5376 22.5376 25 19.5 25C16.4624 25 14 22.5376 14 19.5C14 16.4624 16.4624 14 19.5 14C22.5376 14 25 16.4624 25 19.5Z",
    fill: "#E0F64B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6614d7c9b708dc24193530dd4d1de597.svg";
export { ForwardRef as ReactComponent };